import { MRT_RowData } from "material-react-table";
import { Stack, useTheme, RadioGroup, FormControlLabel, Radio, FormControl, FormLabel } from "@mui/material";
import { CustomMRTFilter } from "../mrt.types";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export type EmptyNullValue = "empty" | "notEmpty" | undefined;

export const EmptyNullFilter = <T extends MRT_RowData>(mrtProps: CustomMRTFilter<T>) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const rawFilterValue = mrtProps.column.getFilterValue();
    const initFilterValue = (
        typeof rawFilterValue === "object" && rawFilterValue !== null && "emptyNull" in rawFilterValue ?
            rawFilterValue.emptyNull
        :   rawFilterValue) as EmptyNullValue;

    const [selectedValue, setSelectedValue] = useState<string>(initFilterValue ?? "all");

    useEffect(() => {
        if (!mrtProps.column) return;

        const timeoutId = setTimeout(() => {
            if (selectedValue === "all") {
                mrtProps.column.setFilterValue(undefined);
            } else if (selectedValue === "empty") {
                mrtProps.column.setFilterValue("empty");
            } else if (selectedValue === "notEmpty") {
                mrtProps.column.setFilterValue("notEmpty");
            }
        }, 100);

        return () => clearTimeout(timeoutId);
    }, [selectedValue, mrtProps.column]);

    return (
        <Stack gap={theme.spacing(1)} sx={{ padding: theme.spacing(1) }}>
            <FormControl component="fieldset">
                <FormLabel component="legend" sx={{ fontSize: "0.875rem", marginBottom: theme.spacing(1) }}>
                    {t("grid.filter.emptyNull.label", "Filtrer par valeur")}
                </FormLabel>
                <RadioGroup
                    value={selectedValue}
                    onChange={(e) => setSelectedValue(e.target.value)}
                    aria-label={t("grid.filter.emptyNull.ariaLabel", "Filter by empty or not empty")}
                >
                    <FormControlLabel
                        value="all"
                        control={<Radio size="small" />}
                        label={t("grid.filter.emptyNull.all", "Tous")}
                    />
                    <FormControlLabel
                        value="empty"
                        control={<Radio size="small" />}
                        label={t("grid.filter.emptyNull.empty", "Vide")}
                    />
                    <FormControlLabel
                        value="notEmpty"
                        control={<Radio size="small" />}
                        label={t("grid.filter.emptyNull.notEmpty", "Non vide")}
                    />
                </RadioGroup>
            </FormControl>
        </Stack>
    );
};
